export const defaultAmount = 10000
